<div style="" *ngFor="let batch of deptRenders | keyvalue">
  <span
    style="width: 13px; height: 13px"
    class="d-inline-block border border-dark rounded-circle {{ batch.value.status }}"></span>
  {{ batch.key }}
</div>
